import { LOCALES } from '../locales';

export default {
  [LOCALES.ENGLISH]: {
    "L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml":
      "L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml",
    'DressBerry Women Peach-Coloured Solid Flats':
      'DressBerry Women Peach-Coloured Solid Flats',
    'ZAPATOZ Women White Sneakers':
      'Crocs Unisex Navy Blue Solid Bayaband Clogs',
    'Crocs Unisex Navy Blue Solid Bayaband Clogs':
      'Crocs Unisex Navy Blue Solid Bayaband Clogs',
    'SASSAFRAS Black & Pink Printed Wrap Dress':
      'SASSAFRAS Black & Pink Printed Wrap Dress',
    'Tokyo Talkies Navy Polka Dot Belted Shirt Dress':
      'Tokyo Talkies Navy Polka Dot Belted Shirt Dress',
    'SASSAFRAS Women Maroon Solid Tiered Maxi Dress':
      'SASSAFRAS Women Maroon Solid Tiered Maxi Dress',
    'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s':
      'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s',
    'MANGO Burgundy Solid Tote Bag': 'MANGO Burgundy Solid Tote Bag',
    HOME: 'HOME',
    Filter: 'Filter',
    Filters: 'Filters',
    Category: 'Category',
    Categories: 'Categories',
    'Search Products': 'Search Products',
    'E-mail': 'E-mail',
    'Sign-in': 'Sign-in',
    Password: 'Password',
    'Create your account': 'Create your account',
    'or sign-in with:': 'or sign-in with:',
    Google: 'Google',
    Facebook: 'Facebook',
    Phone: 'Phone',
    'Hello, Guest': 'Hello, Guest',
    'SHOP NOW': 'SHOP NOW',
    'PARTY WEAR': 'PARTY WEAR',
    'CASUAL WEAR': 'CASUAL WEAR',
    ACCESSORIES: 'ACCESSORIES',
    FOOTWEAR: 'FOOTWEAR',
    'Redefine your fashion with these stunning casual wear':
      'Redefine your fashion with these stunning casual wear',
    'Sophesticated accessories to make your look and life a paradise.':
      'Sophesticated accessories to make your look and life a paradise.',
    'Footwear that makes you comfortable and look good.':
      'Footwear that makes you comfortable and look good.',
    'Dress up for parties with the spirit of passion':
      'Dress up for parties with the spirit of passion',
    German: 'German',
    French: 'French',
    English: 'English',
    'Learn More': 'Learn More',
    'Classic Collection 2021': 'Classic Collection 2021',
    'COLLECTION 2021': 'COLLECTION 2021',
    'Fresh Collection 2021': 'Fresh Collection 2021',
    'Fashion Collection 2021': 'Fashion Collection 2021',
    Login: 'Login',
    Account: 'Account',
    Orders: 'Orders',
    'Featured Products': 'Featured Products',
    'Recommended for you': 'Recommended for you',
    'Tinny Three Quarter Sleeve Dress': 'Tinny Three Quarter Sleeve Dress',
    'Vila Striped T-Shirt Dress': 'Vila Striped T-Shirt Dress',
    'Sleeveless Deana Maxi Dress': 'Sleeveless Deana Maxi Dress',
    About: 'About',
    Services: 'Services',
    Portfolio: 'Portfolio',
    Pricing: 'Pricing',
    Customers: 'Customers',
    Careers: 'Careers',
    Resources: 'Resources',
    Docs: 'Docs',
    Blog: 'Blog',
    eBooks: 'eBooks',
    Contact: 'Contact',
    Help: 'Help',
    Sales: 'Sales',
    Advertise: 'Advertise',
    Webinars: 'Webinars',
    'Stay Updated': 'Stay Updated',
    'Subscribe to our newsletter to get our latest news':
      'Subscribe to our newsletter to get our latest news',
    'Enter email address': 'Enter email address',
    'Terms & Conditions': 'Terms & Conditions',
    'Privacy Policy': 'Privacy Policy',
    Copyright: 'Copyright',
  },
};
